import { render, staticRenderFns } from "./GeneralDocuments.vue?vue&type=template&id=707f2142&"
import script from "./GeneralDocuments.vue?vue&type=script&lang=js&"
export * from "./GeneralDocuments.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDocuments.vue?vue&type=style&index=0&id=707f2142&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./GeneralDocuments.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports